module.exports = __webpack_public_path__ + "media/assets/images/lib/content-tools/ce-drop-right-11be16f3446df9399df6954518b17b18.png";